import iframe_bSales from '../views/iframebSales.vue'
import Layout from '@/apps/bsales/Layouts/LayoutMain.vue'
import retail from '../views/retail_bSales.vue'
import Insurance from '../views/Insurance_bSales.vue'
import Setting_bSales from '../views/Setting_bSales.vue'
import Leads_bSales from '@/apps/Marketea/views/LeadsMark.vue'
import Dash_bSales from '../views/dash_sales.vue'
import Campaigns_bSales from '../views/campaings.vue'
import Landing_bSales from '../views/landing_sales.vue'
const nameApp = 'bSales';
export default [
	{
		path: '/bsales',
		folder: Layout,
		meta: {requiresAuth: true},
		children: [
			{
				path: '/',
				name: 'bSales',
				folder: Leads_bSales
			},
			{
				path: '/leads',
				name: 'Leads_bSales',
				folder: Leads_bSales
			},
			{
				path: '/reail',
				name: 'Retail',
				folder: retail
			},
			{
				path: '/insurance',
				name: 'Insurance',
				folder: Insurance
			},
			{
				path: '/setting',
				name: 'Setting_bSales',
				folder: Setting_bSales
			},
			{
				path: '/dash',
				name: 'Dash_bSales',
				folder: Dash_bSales
			},
			{
				path: '/ads',
				name: 'Campaigns_bSales',
				folder: Campaigns_bSales
			},
			{
				path: '/landing',
				name: 'Landing_bSales',
				folder: Landing_bSales
			},
		]
	}
]
